import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'antd'
import css from './location-active.css'

const LocationActive = ({ onActiveToggle, contactInfoActive }) => (
  <div className={css.wrapper}>
    <Switch
      onClick={() => onActiveToggle(contactInfoActive)}
      checked={contactInfoActive}
    />
    <div>{contactInfoActive ? '- Active' : '- Inactive'}</div>
  </div>
)

LocationActive.propTypes = {
  onActiveToggle: PropTypes.func.isRequired,
  contactInfoActive: PropTypes.bool.isRequired,
}

export default LocationActive



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/LocationActive.js